export function softmax(values) {
  if (!Array.isArray(values) || values.length === 0) return [];
  const max = Math.max(...values);
  const exps = values.map((value) => Math.exp(value - max));
  const sum = exps.reduce((acc, value) => acc + value, 0) || 1;
  return exps.map((value) => value / sum);
}

export function cosineSimilarity(a, b) {
  const length = Math.max(a?.length || 0, b?.length || 0);
  if (length === 0) return 0;
  let dot = 0;
  let normA = 0;
  let normB = 0;
  for (let i = 0; i < length; i += 1) {
    const va = a?.[i] ?? 0;
    const vb = b?.[i] ?? 0;
    dot += va * vb;
    normA += va * va;
    normB += vb * vb;
  }
  const denom = Math.sqrt(normA) * Math.sqrt(normB);
  if (denom === 0) return 0;
  const value = dot / denom;
  return Number.isFinite(value) ? value : 0;
}

export function clamp(value, min, max) {
  if (Number.isNaN(value) || value === undefined || value === null) return min;
  return Math.max(min, Math.min(max, value));
}

export function lerp(a, b, alpha) {
  return a + (b - a) * alpha;
}

export function summarize(values) {
  if (!Array.isArray(values) || values.length === 0) return { mean: 0, variance: 0 };
  const mean = values.reduce((acc, value) => acc + value, 0) / values.length;
  const variance = values.reduce((acc, value) => acc + (value - mean) ** 2, 0) / values.length;
  return { mean, variance };
}

const mathUtils = {
  softmax,
  cosineSimilarity,
  clamp,
  lerp,
  summarize
};

export default mathUtils;

